/**
 * Die Kachel mit der grossen Zahl — einmal, fuer alle, die sie brauchen.
 *
 * Statistik und Detailseite zeigen dieselbe Kachel: Zahl, Beschriftung,
 * Piktogramm, manchmal ein Zusatz darunter. Zwei Fassungen desselben Markups
 * waren schon eine zu viel — die eine bekommt ein Zeichen und die andere
 * nicht, und niemand merkt es, bis beide nebeneinander stehen.
 *
 * Das Zeichen steht **oben rechts, nicht vor der Zahl**: Vor der Zahl schoebe
 * es die Ziffern aus der Flucht, und vier Kacheln nebeneinander leben davon,
 * dass ihre Zahlen auf derselben Linie beginnen.
 *
 * Gefaerbt wird nur, wo die Farbe etwas bedeutet — Tiefe ist Physik, und die
 * Skala ist dieselbe wie in Liste, Profil und Histogramm. Das Piktogramm
 * bleibt leise: Warm gehoert im Bild den Daten.
 */

import { symbolHtml } from '../symbole.js';

export function kennzahl(wert, label, { zusatz = '', zeichen = '', farbe = '', klasse = '' } = {}) {
  return `<div class="kennzahl${klasse ? ` ${klasse}` : ''}">
    ${zeichen ? `<span class="kennzahl-symbol">${symbolHtml(zeichen, 24)}</span>` : ''}
    <span class="wert"${farbe ? ` style="color: ${farbe}"` : ''}>${wert}</span>
    <span class="label">${label}</span>
    ${zusatz ? `<span class="zusatz">${zusatz}</span>` : ''}
  </div>`;
}
